module.exports = __webpack_public_path__ + "img/14dayp.b324a008.svg";